import {
	useDecisionMakerResponsePageData,
	useDecisionMakerResponsePageState,
} from '#src/app/pages/decisionMaker/response/details/pageContext';

type Result = ModelHookResult<
	{ petitionId: string },
	{
		handleSuggestedPetitionsPosition: (below: boolean) => void;
	}
>;

export function usePageFooter(): Result {
	const {
		data: {
			decisionMakerResponse: {
				petition: { id: petitionId },
			},
		},
	} = useDecisionMakerResponsePageData();
	const [, { toggleBeforeSuggestedPetitions }] = useDecisionMakerResponsePageState();

	return {
		data: {
			petitionId,
		},
		actions: {
			handleSuggestedPetitionsPosition: (below) => {
				// if suggested petitions are below, we are before them
				toggleBeforeSuggestedPetitions(below);
			},
		},
	};
}
